"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _useQuestionAndProperty = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/hooks/useQuestionAndProperty"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _immutable = require("immutable");

var _QuestionErrorBlock = _interopRequireDefault(require("./QuestionErrorBlock"));

var getEntityKey = (0, _memoize.default)(function (block) {
  return block.getEntityAt(0);
});
var getQuestionId = (0, _memoize.default)(function (entityKey, getEditorState) {
  var _getEditorState$getCu = getEditorState().getCurrentContent().getEntity(entityKey).getData(),
      questionId = _getEditorState$getCu.questionId;

  return questionId;
});

var QuestionContainerHOC = function QuestionContainerHOC(QuestionBlockComponent) {
  var QuestionContainer = function QuestionContainer(props, context) {
    var block = props.block,
        _props$blockProps = props.blockProps,
        questionsMap = _props$blockProps.questionsMap,
        properties = _props$blockProps.properties,
        onSubmissionChanged = _props$blockProps.onSubmissionChanged,
        getInsertQuestionAndAnswerEnabled = _props$blockProps.getInsertQuestionAndAnswerEnabled,
        otherBlockProps = (0, _objectWithoutProperties2.default)(_props$blockProps, ["questionsMap", "properties", "onSubmissionChanged", "getInsertQuestionAndAnswerEnabled"]),
        otherProps = (0, _objectWithoutProperties2.default)(props, ["block", "blockProps"]);
    var getEditorState = context.getEditorState,
        onChange = context.onChange;
    var entityKey = getEntityKey(block);
    var questionId = getQuestionId(entityKey, getEditorState);

    var _useQuestionAndProper = (0, _useQuestionAndProperty.default)({
      questionId: questionId,
      questionsMap: questionsMap,
      properties: properties
    }),
        question = _useQuestionAndProper.question,
        setQuestion = _useQuestionAndProper.setQuestion,
        property = _useQuestionAndProper.property;

    if (!question) {
      return _react.default.createElement(_QuestionErrorBlock.default, {
        getInsertQuestionAndAnswerEnabled: getInsertQuestionAndAnswerEnabled,
        onEditorStateChange: onChange,
        entityKey: entityKey,
        getEditorState: getEditorState
      });
    }

    return _react.default.createElement(QuestionBlockComponent, Object.assign({
      questionId: questionId,
      question: question,
      setQuestion: setQuestion,
      property: property,
      properties: properties,
      entityKey: entityKey,
      blockKey: block.getKey(),
      getEditorState: getEditorState,
      onEditorStateChange: onChange,
      onSubmissionChanged: onSubmissionChanged,
      getInsertQuestionAndAnswerEnabled: getInsertQuestionAndAnswerEnabled
    }, otherBlockProps, otherProps));
  };

  QuestionContainer.propTypes = {
    block: _propTypes.default.object.isRequired,
    blockProps: _propTypes.default.shape({
      properties: _propTypes.default.instanceOf(_immutable.Map).isRequired,
      questionsMap: _propTypes.default.instanceOf(_immutable.Map).isRequired,
      getInsertQuestionAndAnswerEnabled: _propTypes.default.func,
      saveQuestion: _propTypes.default.func,
      onSubmissionChanged: _propTypes.default.func
    }).isRequired
  };
  QuestionContainer.contextTypes = {
    getEditorState: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired
  };
  return QuestionContainer;
};

var _default = QuestionContainerHOC;
exports.default = _default;
module.exports = exports.default;